import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import apiClient from "@/lib/api-client";

export interface UserNotice {
  type: string;
  ack: boolean;
}

export function useNotices() {
  return useQuery<UserNotice[]>({
    queryKey: ["user-notices"],
    queryFn: () =>
      apiClient.get("api/users/me/notices").json<UserNotice[]>(),
    retry: false,
    // Notices are relatively stable — avoid refetching on every mount.
    staleTime: 60_000,
  });
}

export function useAckIsolationNotice() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () =>
      apiClient
        .post("api/users/me/notices/isolation/ack")
        .json<{ ack: boolean }>(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["user-notices"] });
    },
  });
}
